import { Breakpoints, styled } from '@vw-marketing/us-components';

export const StyledSelect = styled.div`
  width: 100%;
  min-width: 192px;
  flex: 1 0 0;

  @media (min-width: ${Breakpoints.b560}px) {
    &:first-child {
      width: auto;
      max-width: ${(props) => props.theme.size.grid008};
    }
  }

  @media (min-width: ${Breakpoints.b1600}px) {
    &:first-child {
      width: auto;
      max-width: ${(props) => props.theme.size.grid004};
    }
  }
`;

export const StyledErrorMessage = styled.div`
  display: flex;
  margin-top: 10px;
  color: ${(props) => props.theme.colors.signal.error};
`;
